import { Outlet } from "react-router-dom";
import { ThemeProvider } from "./contexts/ThemeProvider";
import { LanguageProvider } from "./contexts/LanguageProvider";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
export default function App() {
  return (
    <LanguageProvider>
      <ThemeProvider>
        <Navbar />
        <div className="min-h-screen ">
          <Outlet />
        </div>
        <Footer />
      </ThemeProvider>
    </LanguageProvider>
  );
}
